import {
  shareNewFeedbackApi,
  getFeedbackDetailsByIdApi,
  requestNewFeedbackApi,
  shareRequestedFeedbackApi,
  archiveFeedbackApi,
  acceptFeedbackApi,
  declineFeedbackApi,
  getLandingPageFeedbackStatsApi,
  getAllSharedFeedbackListApi,
  getAllRequestedFeedbackListApi,
  getAllSharedFeedbackListV1Api,
  getAllReceivedFeedbackListV1Api,
  getFeedbackTableApi,
  getReceivedFeedbackTableApi,
  getRequestedFeedbackApi,
  getSharedOrReceivedFeedbackApi,
  getDeleteReceivedFeedbackApi,
} from 'api/continuousFeedback';
import ColorCodedDate from 'models/common/ColorCodedDate';
import ContinuousFeedbackReview from 'models/continuousFeedback';
import { BasicEmployee } from 'models/employee';
import Post from 'models/post';

export const shareNewFeedback = ({ body, nudgeId, receiverIds = [], is_new_panel = false }) =>
  shareNewFeedbackApi({ body, nudgeId, receiverIds, is_new_panel }).then((res) => res.entity);

export const getFeedbackDetailsById = ({ feedbackId }) =>
  getFeedbackDetailsByIdApi({ feedbackId }).then((res) => {
    const { employee, review, deadline } = res.entity;
    return {
      deadline,
      employee: BasicEmployee.fromJSON(employee),
      review: ContinuousFeedbackReview.fromJSON(review),
    };
  });

export const requestNewFeedback = ({ body, providerIds = [], is_new_panel = false }) =>
  requestNewFeedbackApi({ body, providerIds, is_new_panel }).then((res) => res.entity);

export const shareRequestedFeedback = ({ body, feedbackId, is_new_panel = false }) =>
  shareRequestedFeedbackApi({ body, feedbackId, is_new_panel }).then((res) => res.entity);

export const archiveFeedback = ({ feedbackId }) => archiveFeedbackApi({ feedbackId }).then((res) => res.entity);

export const acceptFeedback = ({ feedbackId }) => acceptFeedbackApi({ feedbackId }).then((res) => res.entity);

export const declineFeedback = ({ feedbackId }) => declineFeedbackApi({ feedbackId }).then((res) => res.entity);

export const getLandingPageFeedbackStats = () => getLandingPageFeedbackStatsApi().then((res) => res.entity);

export const getAllSharedFeedbackList = () =>
  getAllSharedFeedbackListApi().then((res) =>
    res.entity.map((item) => ({
      ...item,
      review: {
        ...item.review,
        requestedDateFormatted:
          item.review.requestedDateFormatted && ColorCodedDate.fromJSON(item.review.requestedDateFormatted),
        submissionDateFormatted:
          item.review.submissionDateFormatted && ColorCodedDate.fromJSON(item.review.submissionDateFormatted),
      },
    }))
  );

export const getAllRequestedFeedbackList = () =>
  getAllRequestedFeedbackListApi().then((res) =>
    res.entity.map((item) => ({
      ...item,
      review: {
        ...item.review,
        requestedDateFormatted:
          item.review.requestedDateFormatted && ColorCodedDate.fromJSON(item.review.requestedDateFormatted),
        submissionDateFormatted:
          item.review.submissionDateFormatted && ColorCodedDate.fromJSON(item.review.submissionDateFormatted),
      },
    }))
  );

export function getAllSharedFeedbackListV1({ limit, offset, feedbackType }) {
  return getAllSharedFeedbackListV1Api({ limit, offset, feedbackType }).then((res) =>
    res.entity.map((data) => Post.fromJSON(data.post))
  );
}

export function getAllReceivedFeedbackListV1({ limit, offset, feedbackType }) {
  return getAllReceivedFeedbackListV1Api({ limit, offset, feedbackType }).then((res) =>
    res.entity.map((data) => Post.fromJSON(data.post))
  );
}

export function getFeedbackTable({ limit, offset, feedbackStatus, employeeId }) {
  return getFeedbackTableApi({ limit, offset, feedbackStatus, employeeId }).then((res) => res.entity);
}

export function getReceivedFeedbackTable({ limit, offset, employeeId }) {
  return getReceivedFeedbackTableApi({ limit, offset, employeeId }).then((res) => res.entity);
}

export function getRequestedFeedbackData({ feedbackId }) {
  return getRequestedFeedbackApi({ feedbackId }).then((res) => res.entity);
}

export function getSharedOrReceivedFeedbackData({ postId }) {
  return getSharedOrReceivedFeedbackApi({ postId }).then((res) => res.entity);
}

export function deleteReceivedFeedbackData({ feedbackId }) {
  return getDeleteReceivedFeedbackApi({ feedbackId }).then((res) => res.entity);
}
